import React from 'react'

import './style.css';

export default function HeroSec() {
  return (
    <div className="hero">
        <div className="hero-image">
        

    </div>
    <div className="frame-497">
            <div className="text-box">
            <p>We crush your competitors, goals, and sales records - without the B.S.</p>
            </div>
           
            <button>GET FREE CONSULTION</button>
        </div>
    </div>
        




        



  )
}
